import { IBrowser } from '@/models';

class CheckDevice {

  public other = 'other'
  public safari = 'safari'
  public undifined = 'undifined'
  public android = 'android'
  public ios = 'ios'
  public chrome = 'chrome'
  public edge = 'edge'

  public isMobile = (): boolean => {
    return /Android|iPhone|iPad|iPod|IEMobile|BlackBerry|Opera Mini/i.test(
      navigator.userAgent
    )
  }

  public browser(): IBrowser {
    const ua = navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return {
        name: 'IE',
        version: (tem[1] || '')
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return {
      name: M[0].toLocaleLowerCase(),
      version: M[1]
    };
  }

  public iOSBrowerName() {
    if (!navigator.userAgent) return this.undifined
    if (navigator.userAgent.match('Version/')) return this.safari
    if (navigator.userAgent.match('CriOS')) return this.chrome
    if (navigator.userAgent.match('EdgiOS')) return this.edge
    else return this.other
  }

  public getMobileOS() {
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera

    // Android
    if (/android/i.test(userAgent)) return this.android

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    const isIOS =
      /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream

    // iPad iOS 13+ giả desktop
    const isModernIpad =
      navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1

    if (isIOS || isModernIpad) return this.ios

    return this.other
  }
}

export default new CheckDevice()
